import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getHotArticles, formatCount, getCategoryName } from '@/lib/content';
import type { Article } from '@/types/content';

export default function ArticleSidebar() {
  const hot = getHotArticles(5);

  return (
    <aside className="flex w-full flex-col gap-5 lg:w-80 lg:shrink-0">
      <div className="rounded-lg border border-background-200 bg-background-100/60 p-5">
        <h2 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
          <i className="ri-fire-line text-accent-600" aria-hidden="true"></i>
          全站热读
        </h2>
        <ul className="mt-4 flex flex-col gap-4">
          {hot.map((item: Article, idx) => (
            <li key={item.id} className="flex gap-3">
              <span className="font-heading text-lg text-foreground-300">{idx + 1}</span>
              <div className="min-w-0">
                <Link
                  to={`/article/${item.id}`}
                  className="line-clamp-2 text-sm font-medium text-foreground-800 transition-colors hover:text-primary-700"
                >
                  {item.title}
                </Link>
                <p className="mt-1 text-xs text-foreground-500">
                  {getCategoryName(item.category)} · {formatCount(item.views)} 次围观
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
          <i className="ri-layout-grid-line text-secondary-700" aria-hidden="true"></i>
          换个栏目翻翻
        </h2>
        <div className="mt-4 flex flex-wrap gap-2">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 transition-colors hover:bg-secondary-200"
            >
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </aside>
  );
}